/**
 * Extrae los parámetros de tracking UTM de un objeto query de ruta.
 * Retorna null si no hay ningún parámetro UTM presente.
 *
 * @param {Object} query - El objeto query de $route.query
 * @returns {Object|null} Objeto con los 4 campos UTM, o null si no hay ninguno
 */
export function buildUtmParams(query) {
    const params = {
        utm_source:   query.utm_source   ?? null,
        utm_medium:   query.utm_medium   ?? null,
        utm_campaign: query.utm_campaign ?? null,
        utm_content:  query.utm_content  ?? null,
    };

    const hasUtm = Object.values(params).some(v => v !== null);

    return hasUtm ? params : null;
}
